<template>
    <div>
		<div v-if="internetOffline" class="database-offline-overlay">
			<div class="database-offline-modal">
				<div class="database-offline-icon">🌐</div>

				<h2>Brak połączenia z Internetem</h2>

				<p>
					Utracono połączenie z Internetem.
					<br>
					Sprawdź połączenie sieciowe.
					<br>
					System automatycznie spróbuje ponownie.
				</p>

				<div class="database-offline-loader"></div>
			</div>
		</div>

		<div v-else-if="databaseOffline" class="database-offline-overlay">
			<div class="database-offline-modal">
				<div class="database-offline-icon">⚠️</div>

				<h2>Brak połączenia z bazą danych</h2>

				<p>
					Nie można połączyć się z bazą danych.
					<br>
					System automatycznie spróbuje ponownie.
				</p>

				<div class="database-offline-loader"></div>
			</div>
		</div>

      <Header>
        <template #subheader>
          <slot name="subheader"></slot>
        </template>
      </Header>
        <FlashNotifications></FlashNotifications>

        <div class="main-container" id="container" :class="[!$store.state.is_show_sidebar ? 'sidebar-closed sbar-open' : '', $store.state.menu_style === 'collapsible-vertical' ? 'collapsible-vertical-mobile' : '']">
            <div class="overlay" :class="{ show: !$store.state.is_show_sidebar }" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)"></div>

            <!--<div class="search-overlay" :class="{ show: $store.state.is_show_search }" @click="$store.commit('toggleSearch', !$store.state.is_show_search)"></div>-->

            <Sidebar></Sidebar>
            <div id="content" class="main-content">
                <div class="layout-px-spacing">
                    <div class="middle-content p-0">
                        <div class="row layout-top-spacing">

                            <slot/>

                        </div>
                    </div>
                </div>

                <Footer></Footer>
            </div>
        </div>
    </div>
</template>

<script setup>
import '../../assets/sass/app.scss';

import Header from "../Components/Layout/header.vue";
import Sidebar from "../Components/Layout/sidebar.vue";
import Footer from "../Components/Layout/footer.vue";
import FlashNotifications from "../Components/FlashNotifications.vue";

import { ref, onMounted, onUnmounted } from 'vue';

let twoFactorInterval = null;
let databaseInterval = null;

const databaseOffline = ref(false);
const internetOffline = ref(!navigator.onLine);

const handleOffline = () => {
    internetOffline.value = true;
};

const handleOnline = () => {
    internetOffline.value = false;

    // Po odzyskaniu Internetu od razu sprawdź bazę
    checkDatabase();
};

const checkDatabase = async () => {
    try {
        const response = await fetch('/auth/check-db', {
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
            },

            // Nie pozwól, żeby przeglądarka użyła starej odpowiedzi
            cache: 'no-store',
        });

        databaseOffline.value = !response.ok;

    } catch (error) {
        if (!navigator.onLine) {
            internetOffline.value = true;
            databaseOffline.value = false;
        } else {
            databaseOffline.value = true;
        }
    }
};

onMounted(() => {
    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    twoFactorInterval = setInterval(async () => {
        if (!navigator.onLine) {
            return;
        }

        try {
            const response = await fetch('/auth/check-2fa', {
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json',
                },
                cache: 'no-store',
            });

            if (response.status === 401) {
                window.location.href = '/';
            }

        } catch (error) {
            console.error('2FA check error:', error);
        }
    }, 10000);

    checkDatabase();
    databaseInterval = setInterval(checkDatabase, 5000);
});

onUnmounted(() => {
    clearInterval(twoFactorInterval);
    clearInterval(databaseInterval);

    window.removeEventListener('offline', handleOffline);
    window.removeEventListener('online', handleOnline);
});
</script>

<script>

import FlashNotifications from "../Components/FlashNotifications.vue";

export default {
    components: {FlashNotifications},
}
</script>
<style>
.database-offline-overlay {
    position: fixed;
    inset: 0;
    z-index: 999999;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
}

.database-offline-modal {
    width: 90%;
    max-width: 500px;
    padding: 40px;
    background: #fff;
    border-radius: 12px;
    text-align: center;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

.database-offline-icon {
    font-size: 50px;
    margin-bottom: 15px;
}

.database-offline-modal h2 {
    margin-bottom: 15px;
}

.database-offline-modal p {
    margin-bottom: 25px;
}

.database-offline-loader {
    width: 35px;
    height: 35px;
    margin: 0 auto;
    border: 4px solid #ddd;
    border-top-color: #333;
    border-radius: 50%;
    animation: database-loader-spin 1s linear infinite;
}

@keyframes database-loader-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>